import { AppBar, AppBarProps, Container, Toolbar, useTheme } from '@mui/material'
import { FlexGrowRow } from '@xylabs/sdk-react'
import React from 'react'
import { Link } from 'react-router-dom'

import { SystemToolbar } from '../Toolbar'
import logo from './img/logo.png'

const PortalAppBar: React.FC<AppBarProps> = ({ children, ...props }) => {
  const theme = useTheme()
  return (
    <AppBar
      position="sticky"
      style={{
        backgroundColor: theme.palette.background.paper,
      }}
      {...props}
    >
      <Container maxWidth="xl">
        <FlexGrowRow flexWrap="wrap" justifyContent="flex-start">
          <Toolbar disableGutters>
            <Link to="/" style={{ alignItems: 'center', display: 'flex', marginLeft: theme.spacing(1) }}>
              <img src={logo} height="32" width="auto" />
            </Link>
          </Toolbar>
          {children}
          <FlexGrowRow />
          <SystemToolbar />
        </FlexGrowRow>
      </Container>
    </AppBar>
  )
}

export default PortalAppBar
